export const getLast12MonthsDates: () => string[] = () => {
    const dates: string[] = []
    const now = new Date()

    for (let i = 0; i < 12; i++) {
        // Use UTC-based date calculations
        const date = new Date(
            Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i - 1, 1)
        )
        dates.unshift(date.toISOString())
    }

    return dates
}
